import { Component } from "@angular/core";
import { NavController, NavParams, AlertController } from "ionic-angular";
import { FirebaseService } from "../../services/firebase.service";
import { AppInfo } from "../../app/credentials";

@Component({
  selector: "page-send-feedback",
  templateUrl: "send-feedback.html"
})
export class SendFeedbackPage {
  public ver: string = "";

  title = "";
  description = "";
  type = "request";

  constructor(public navCtrl: NavController, public navParams: NavParams, private FireSrvc: FirebaseService,private alertCtrl: AlertController) {
    this.ver = AppInfo.Version;
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad SendFeedbackPage");
  }

  Send() {
    // Verifca siano compiati tutti i campi
    if (this.title.trim() != "" && this.description.trim() != "" && this.type.trim() != "") {
      // Invia segnalazione
      this.FireSrvc.AddFeedback(this.title, this.description, this.type);
       this.presentAlert()
      this.navCtrl.pop();
    } else {
      alert("Per favore compila tutti i campi");
    }
  }

  async  presentAlert() {
    let alert = await this.alertCtrl.create({
      title: 'Invio completato!',
      subTitle: 'Grazie, ti invieremo una mail per informarti degli sviluppi. Il tuo contributo è prezioso per noi! BUONA LETTURA! ',

      buttons: ['ok']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/send-feedback/send-feedback.ts